import * as React from 'react'
import '../styles/CustomTextArea.scss'
import { StringResources } from '../localization/StringResources'
import { Strings } from '../localization'

interface CommentProps {
  note: string,
  commentChange: (event: any) => void
  maxCommentLength: number
  isCounterRequired: boolean
  saveTextareaHeight: (minHeight: number) => void
  minHeight: number
}

interface CommentState {
  minHeight: number
  charactersLeft: number
}

export default class Comment extends React.Component<CommentProps, CommentState> {
  constructor(props: any) {
    super(props)
    this.state = {
      minHeight: !!this.props.note ? 50 : this.props.minHeight,
      charactersLeft: this.props.maxCommentLength - (this.props.note || '').length
    }
  }

  resize = (event) => {
    if (this.state.minHeight !== event.target.scrollHeight) {
      this.setState({
        minHeight: event.target.scrollHeight
      })
      this.props.saveTextareaHeight(event.target.scrollHeight)
    }
    localStorage.setItem('textarea_min_height', event.target.scrollHeight)
  }

  onCommentChange = (event) => {
    this.props.commentChange(event)
    this.setState({ charactersLeft: this.props.maxCommentLength - event.target.value.length })
  }

  keyDown = (e) => {
    if (e.keyCode === 13) {
      e.preventDefault()
    }
  }

  render() {
    return (
      <div className="textarea-container">
        {
          this.props.isCounterRequired ?
            <div className="counter">
              <label>{`${this.state.charactersLeft} ${StringResources.getString(Strings.Components.Comment.Labels.CharsLeft.Text)}`}</label>
            </div>
            : null
        }
        <textarea
          value={this.props.note}
          onChange={this.onCommentChange}
          onKeyDown={this.keyDown}
          onInput={this.resize}
          style={{ height: this.state.minHeight }}
          maxLength={5000}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Comment.tsx